import { Decimal } from 'decimal.js'
import type { ReceiptGroup } from './types.ts'

const BILL_KINDS: Record<string, string> = {
  rent: '租金',
  water: '水费',
  electricity: '电费',
  service: '服务费',
  deposit: '押金',
  other: '其他',
  propertyManagement: '物业费',
  commission: '佣金',
  outsourcing: '外包',
  salary: '工资',
  reimbursement: '报销',
  repair: '维修',
  office: '办公',
  passThrough: '代收代付'
}

export function snapshotObject(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : {}
}

export function snapshotValue(value: unknown, field: string) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return '—'
  }
  const data = (value as Record<string, unknown>)[field]
  return typeof data === 'string' || typeof data === 'number' ? String(data) : '—'
}

// 页面预览、复制图片、打印和 PDF 共用；调整列宽只改这里，百分比合计保持 100%。
export const RECEIPT_COLUMNS = [
  { title: '订单／账单编号', width: '14%' },
  { title: '服务对象', width: '8%' },
  { title: '地址', width: '22%' },
  { title: '费用类型', width: '8%' },
  { title: '业务类型', width: '8%' },
  { title: '费用期间', width: '18%' },
  { title: '数量', width: '4%' },
  { title: '单价', width: '8%' },
  { title: '总价', width: '10%' }
] as const
export const RECEIPT_NOTICE =
  '本单依据出单时的账单与账户快照生成，金额为出单应收金额；实际到账以资金流水为准。历史地址缺失时取关联租赁订单的地址快照，其余缺失信息以「—」显示。'
export function receiptPrice(value: unknown) {
  if ((typeof value !== 'string' && typeof value !== 'number') || String(value).trim() === '') return '—'
  try {
    const amount = new Decimal(value)
    return amount.isFinite() ? amount.toFixed(2, Decimal.ROUND_HALF_UP) : '—'
  } catch {
    return '—'
  }
}
export function receiptCells(item: ReceiptGroup['items'][number]) {
  const bill = snapshotObject(item.billSnapshot),
    address = snapshotObject(bill.addressSnapshot)
  return [
    `${snapshotValue(bill, 'sourceOrderNo')}\n${snapshotValue(bill, 'billNo')}`,
    snapshotValue(bill, 'subjectName'),
    bill.serviceOrderId ? '-' : receiptAddress(address, bill.roomNo),
    BILL_KINDS[item.feeType],
    snapshotValue(bill, 'businessName'),
    `${snapshotValue(bill, 'periodStart')} 至 ${snapshotValue(bill, 'periodEnd')}`,
    String(bill.quantity == null ? 1 : Number(bill.quantity)),
    receiptPrice(bill.unitPrice),
    `¥${receiptPrice(item.outstandingAmountSnapshot)}`
  ]
}

function receiptAddress(address: Record<string, unknown>, roomNo: unknown) {
  const parts = address.fullAddress
    ? [address.fullAddress]
    : [address.provinceName, address.cityName, address.districtName, address.detailAddress]
  const room = address.roomNo ?? roomNo
  return (
    [...parts, room ? String(room) : null]
      .filter((value) => typeof value === 'string' && value.trim())
      .join('')
      .replace(/\s+/g, '') || '—'
  )
}
